// La empresa con que se trabaja, en la cabecera del menú lateral (DA-16).
// Con varias, al tocarla se escoge otra. Mismo diseño en el CRM
// (componentes/SelectorEmpresa.jsx): si se cambia aquí, se cambia allá.
import React, { useState } from 'react';
import { ArrowDropDown, Check } from '@mui/icons-material';
import { Box, Chip, ListItemIcon, ListItemText, Menu, MenuItem, Typography } from '@mui/material';

import { cambiarDeEmpresa } from '../empresa';

export default function SelectorEmpresa({ empresas, actual, respaldo }) {
  const [ancla, setAncla] = useState(null);
  const esta = empresas.find((e) => e.identificador === actual);
  const nombre = esta?.nombre || respaldo;
  const varias = empresas.length > 1;

  return (
    <>
      <Box onClick={varias ? (e) => setAncla(e.currentTarget) : undefined}
           role={varias ? 'button' : undefined} aria-label={varias ? 'Cambiar de empresa' : undefined}
           sx={{ display: 'flex', alignItems: 'center', gap: 0.25, mt: 0.25, minWidth: 0,
                 cursor: varias ? 'pointer' : 'default', borderRadius: 1,
                 '&:hover': varias ? { color: '#fff' } : {} }}>
        <Typography noWrap title={nombre} sx={{ fontSize: 11.5, color: varias ? '#cbd5e1' : '#94a3b8',
                                                 fontWeight: varias ? 600 : 400 }}>
          {nombre}
        </Typography>
        {varias && <ArrowDropDown sx={{ fontSize: 18, color: '#94a3b8', flexShrink: 0 }} />}
      </Box>
      <Menu anchorEl={ancla} open={Boolean(ancla)} onClose={() => setAncla(null)}>
        <Typography sx={{ px: 2, pt: 0.5, pb: 1, fontSize: 12, color: 'text.secondary' }}>
          Cambiar de empresa
        </Typography>
        {empresas.map((e) => (
          <MenuItem key={e.identificador} selected={e.identificador === actual}
                    onClick={() => (e.identificador === actual ? setAncla(null) : cambiarDeEmpresa(e.identificador))}>
            <ListItemIcon>{e.identificador === actual && <Check fontSize="small" />}</ListItemIcon>
            <ListItemText primaryTypographyProps={{ fontSize: 13.5 }}>{e.nombre}</ListItemText>
            {e.demo && <Chip size="small" label="Demo" variant="outlined" color="secondary"
                             sx={{ ml: 1, height: 18, fontSize: 10 }} />}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
